export const WorkInstructionFlag = Object.freeze({
  NO_WORK_INSTRUCTION: 0, // 作業指示有無 なし
  WORK_INSTRUCTION: 1 // 作業指示有無 あり
})



// WEBPACK FOOTER //
// ./src/enums/work-instruction.enums.js